import { withChartLayout } from 'components/common';
import EdinburghPostnatalDepressionScale from 'components/features/chart/special-charts/edinburgh-postnatal-depression-scale/EdinburghPostnatalDepressionScale';

const EdinburghPostnatalDepressionScalePage = withChartLayout('Edinburgh Postnatal Depression Scale')(EdinburghPostnatalDepressionScale);
export default EdinburghPostnatalDepressionScalePage;
